import React, { useEffect } from 'react'
import { CircularProgressbar } from '../CircularProgressbar'

import { DeleteIcon, WarningIcon, SuccessIcon } from '../../../../icons/Icons'

import { useAttachmentFile } from './useAttachmentFile'
import { getImgSrc } from './util'

const getActionBackground = status => {
  if (status !== 'success') {
    return {
      background:
        'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9))',
    }
  }
  return null
}

export const AttachmentFile = props => {
  const { classes } = props
  const { status, getFileLink, percentUpload, onStopUpload, loadedFile } =
    useAttachmentFile(props.file)
  const typeFile = props.file.type.split('/')[0]
  const imgSrc = getImgSrc(props.file, typeFile)

  useEffect(() => {
    getFileLink()
    return () => onStopUpload()
  }, [])

  useEffect(() => {
    if (status !== 'loading') {
      props.updateLoadedFiles(loadedFile)
    }
  }, [loadedFile])
  const handleDelete = () => props.removeFile(props.file.name)

  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <img src={imgSrc} alt={`image ${props.index}`} />
        <div
          className={classes.actions}
          style={{ ...getActionBackground(status) }}>
          <div className={classes.status}>
            {status === 'loading' && (
              <CircularProgressbar value={percentUpload} />
            )}
            {status === 'error' && <WarningIcon />}
            {status === 'success' && <SuccessIcon />}
          </div>
          <div className={classes.deleteButton} onClick={handleDelete}>
            <DeleteIcon />
          </div>
        </div>
      </div>
      <p title={props.file.name} className={classes.title}>
        {props.file.name}
      </p>
    </div>
  )
}
